/**
 * Admin maxiature for a Yatzy level: the miniature's card (see adminlevelminiature.js) with the
 * level's remaining fields written under the sheet.
 */

AdminLevelMaxiature.yatzy = function (adminLevel) {
    return AdminLevelMiniature.yatzyCard(adminLevel, cleverapps.styles.AdminLevelYatzyCard.maxiature);
};
